<template>
  <div class="error-container">
    <ErrorMessage :name="name" />
  </div>
</template>
<style lang="scss" scoped>
.error-container {
  width: 100%;
  text-align: left;
  span[role="alert"] {
    color: $error-color;
  }
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { ErrorMessage } from "vee-validate";
import { Prop } from "vue-property-decorator";

@Options({
  components: { ErrorMessage }
})
export default class FieldError extends Vue {
  @Prop({ type: String, required: true }) name = "";
}
</script>
